import { supabase } from '../supabaseClient';
import { loadOperationalPropertyStructure } from './plotMigrationReviewService';
import { integrateOperationalProperties } from './operationalPropertiesService';
import { loadCollaboration } from './collaborationService';
import { attachCollaborationPermissions, propertiesForModule } from '../utils/collaborationAccess';

export function mergeAuthorizedProperties(owned = [], shared = [], shares = []) {
  const roles = new Map((shares || []).map(item => [String(item.propriedade_id), item.role || 'viewer']));
  const combined = [
    ...(shared || []).map(item => ({ ...item, _accessRole: roles.get(String(item.id)) || 'viewer' })),
    // A propriedade própria prevalece caso uma política antiga também a devolva
    // na consulta de compartilhamentos.
    ...(owned || []).map(item => ({ ...item, _accessRole: 'owner' })),
  ];
  return [...new Map(combined.map(item => [String(item.id), item])).values()]
    .sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR'));
}

export async function loadAuthorizedProperties(userId, columns = '*', module = null) {
  if (!userId) return { properties: [], ownedCount: 0, sharedCount: 0 };

  const [ownedResult, sharesResult] = await Promise.all([
    supabase.from('propriedades').select(columns).eq('user_id', userId),
    supabase
      .from('propriedades_compartilhadas')
      .select('propriedade_id, role')
      .eq('user_id', userId)
      .eq('ativo', true)
      .eq('status', 'aceito'),
  ]);

  if (ownedResult.error) throw ownedResult.error;
  if (sharesResult.error) throw sharesResult.error;

  const shares = sharesResult.data || [];
  let shared = [];
  if (shares.length > 0) {
    const sharedResult = await supabase
      .from('propriedades')
      .select(columns)
      .in('id', shares.map(item => item.propriedade_id));
    if (sharedResult.error) throw sharedResult.error;
    shared = sharedResult.data || [];
  }

  const owned = ownedResult.data || [];
  const merged = mergeAuthorizedProperties(owned, shared, shares);
  const collaboration = process.env.REACT_APP_COLLABORATION_ENABLED === 'true' && shared.length
    ? await loadCollaboration() : null;
  return {
    properties: propertiesForModule(collaboration ? merged.map(property => attachCollaborationPermissions(property, collaboration.invitations, userId)) : merged, module),
    ownedCount: owned.length,
    sharedCount: shared.length,
  };
}

export async function loadVisibleAuthorizedProperties(userId, columns = '*', module = null) {
  const scope = await loadAuthorizedProperties(userId, columns, module);
  if (scope.properties.length === 0) return scope;

  const structure = await loadOperationalPropertyStructure();
  const properties = integrateOperationalProperties(scope.properties, structure);
  return {
    properties,
    ownedCount: properties.filter(item => item._accessRole === 'owner').length,
    sharedCount: properties.filter(item => item._accessRole !== 'owner').length,
  };
}
